import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? match[1] : null;

    if (!session_id) {
      navigate("/signin", { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        setUser(r.data.user);
        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true, state: { user: r.data.user } });
      } catch (e) {
        navigate("/signin", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F6F0]">
      <div className="text-center">
        <div className="h-12 w-12 mx-auto rounded-full border-4 border-[#E65A28] border-t-transparent animate-spin" />
        <p className="mt-4 font-serif text-lg text-[#0A192F]">Signing you in...</p>
      </div>
    </div>
  );
}
